<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Política de Cookies - Casato Brasil
    </h1>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">
      Última atualização: 6 de maio de 2026
    </p>

    <div class="self-stretch justify-start mt-20 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <section class="mt-6">
        <h2 class="font-bold">1. O que são cookies</h2>
        <p class="mt-1">
          Cookies são pequenos arquivos de texto armazenados no dispositivo do usuário, como computador, tablet ou smartphone, quando um site é acessado.
        </p>
        <p class="mt-1">
          Esses arquivos ajudam no funcionamento técnico da Plataforma, permitindo recursos como autenticação, manutenção de sessão, segurança, estabilidade da navegação e execução adequada de funcionalidades essenciais.
        </p>
        <p class="mt-1">
          Alguns cookies são removidos ao encerrar a navegação (cookies de sessão), enquanto outros podem permanecer por período limitado necessário à sua finalidade técnica.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">2. Responsável pela Plataforma</h2>
        <p class="mt-1">
          A plataforma Casato Brasil é operada por Muse Digital, responsável pela gestão comercial e operacional da marca Casato Brasil.
        </p>
        <p class="mt-1">Para assuntos relacionados à privacidade e cookies:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">3. Quais cookies utilizamos</h2>
        <p class="mt-1">
          Atualmente, a Casato utiliza apenas cookies e tecnologias estritamente necessários para o funcionamento da Plataforma.
        </p>
        <p class="mt-1">Esses cookies podem ser classificados nas seguintes categorias:</p>

        <h3 class="mt-4 font-bold">a) Cookies Essenciais</h3>
        <p class="mt-1">Necessários para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>autenticação de usuários</li>
          <li>manutenção de sessão ativa</li>
          <li>funcionamento técnico da conta do usuário</li>
          <li>navegação segura entre áreas protegidas</li>
        </ul>

        <h3 class="mt-4 font-bold">b) Cookies de Segurança</h3>
        <p class="mt-1">Utilizados para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>prevenção a fraudes e abusos</li>
          <li>proteção contra acessos indevidos</li>
          <li>integridade técnica da Plataforma</li>
        </ul>

        <h3 class="mt-4 font-bold">c) Cookies de Pagamento</h3>
        <p class="mt-1">Utilizados quando aplicável para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>processamento técnico de pagamentos</li>
          <li>funcionamento do checkout</li>
          <li>prevenção a fraude em transações</li>
        </ul>
        <p class="mt-1">
          Esses cookies são utilizados por serem necessários à prestação do serviço e ao funcionamento seguro da Plataforma, conforme legislação aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">4. Cookies que não utilizamos no momento</h2>
        <p class="mt-1">No momento, não utilizamos:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>cookies analíticos comportamentais</li>
          <li>cookies de publicidade</li>
          <li>cookies de remarketing</li>
          <li>cookies de rastreamento invasivo</li>
          <li>cookies de personalização avançada para marketing</li>
        </ul>
        <p class="mt-1">
          A Casato poderá utilizar ferramentas externas relacionadas à indexação, segurança ou desempenho em mecanismos de busca, que não necessariamente envolvem cookies no dispositivo do usuário.
        </p>
        <p class="mt-1">
          Caso isso mude no futuro, esta Política poderá ser atualizada.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">5. Cookies de terceiros</h2>
        <p class="mt-1">
          Durante determinadas funcionalidades, poderão ser utilizados cookies técnicos operados por fornecedores especializados, incluindo:
        </p>
        <ul class="mt-1 list-disc pl-6">
          <li>Stripe, para checkout, pagamentos e prevenção à fraude</li>
          <li>serviços especializados de autenticação e segurança</li>
          <li>ferramentas técnicas necessárias ao funcionamento da Plataforma</li>
        </ul>
        <p class="mt-1">
          Esses recursos podem estar sujeitos às políticas próprias de seus respectivos fornecedores.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">6. Consentimento</h2>
        <p class="mt-1">
          Como a Plataforma utiliza atualmente apenas cookies estritamente necessários ao funcionamento do serviço, determinados cookies poderão ser utilizados sem consentimento prévio, conforme legislação aplicável.
        </p>
        <p class="mt-1">
          Se categorias não essenciais forem adicionadas futuramente, o usuário será informado e, quando exigido por lei, poderá escolher suas preferências por meio de mecanismos adequados de gestão de consentimento.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">7. Gerenciamento de cookies</h2>
        <p class="mt-1">
          O usuário poderá controlar ou bloquear cookies diretamente nas configurações de seu navegador.
        </p>
        <p class="mt-1">A desativação de cookies essenciais poderá comprometer funcionalidades como:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>login</li>
          <li>segurança da conta</li>
          <li>permanência em sessão</li>
          <li>checkout e pagamentos</li>
          <li>uso regular da Plataforma</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">8. Atualizações desta Política</h2>
        <p class="mt-1">
          Esta Política poderá ser alterada periodicamente para refletir mudanças legais, técnicas ou operacionais.
        </p>
        <p class="mt-1">
          A versão vigente estará sempre disponível na Plataforma com indicação da data da última atualização.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">9. Contato</h2>
        <p class="mt-1">
          Para dúvidas relacionadas ao uso de cookies ou ao tratamento de dados pessoais:
        </p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>
    </div>
  </div>
</div>
